import { render, staticRenderFns } from "./CarSelect.vue?vue&type=template&id=6953b06f&lang=pug&"
import script from "./CarSelect.vue?vue&type=script&lang=ts&"
export * from "./CarSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports